module.exports = __webpack_public_path__ + "img/9.28946315.jpg";